import { GetterTree } from 'vuex'
import { SoundState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<SoundState, RootState> = {
    callSounds: state => state.callSounds,
    ivrMenu: state => state.ivrMenu,
};